import assert from "assert";

// Index is inherent to logon identity
export class IPortal {

  // Returns a promise
  retrieveContent() {
    assert(false, 'Portal.retrieveContent function not implimented')
  }

  // Returns a promise
  retrieveContentSample() {
    assert(false, 'Portal.retrieveContentSample function not implimented')
  }

  // Returns a promise
  storeContent() {
    assert(false, 'Portal.storeContent function not implimented')
  }

  publishContent() {
    assert(false, 'Portal.publishContent function not implimented')
  }

  retrieveSection(sectionName) {
    assert(false, 'Portal.retrieveSection function not implimented')
  }

  storeSection(sectionName, section, order) {
    assert(false, 'Portal.storeSection function not implimented')
  }

  listSections() {
    assert(false, 'Portal.listSections function not implimented')
  }

  retrieveFileUploadURL(fileName, options) {
    assert(false, 'Portal.retrieveFileUploadURL function not implimented')
  }

  retrieveFileDownloadURL(fileName, contentDisposition) {
    assert(false, 'Portal.retrieveFileDownloadURL function not implimented')
  }

  listFileUpload() {
    assert(false, 'Portal.listFileUpload function not implimented')
  }

  removeFileUploadFile(fileName) {
    assert(false, 'Portal.removeFileUploadFile function not implimented')
  }

  retrieveMessages(sofId) {
    assert(false, 'Portal.retrieveMessages function not implimented')
  }

  retrieveRecentMessages() {
    assert(false, 'Portal.retrieveRecentMessages function not implimented')
  }

  retrieveMessagesAsSOF() {
    assert(false, 'Portal.retrieveMessagesAsSOF function not implimented')
  }

  sendMessage(destinationId, message) {
    assert(false, 'Portal.sendMessage function not implimented')
  }

  sendMessageAsSOF(companyId, message) {
    assert(false, 'Portal.sendMessageAsSOF function not implimented')
  }

  storeCriteria(criteia) {
    assert(false, 'DxCompany.storeCriteria function is not implemented')
  }

  retrieveCriteria() {
    assert(false, 'DxCompany.retrieveCriteria function is not implemented')
  }

  searchSOF(queryString, size, from) {
    assert(false, 'Portal.searchSOF function not implemented')
  }

  searchSOFCSV(queryString, size, from) {
    assert(false, 'Portal.searchSOFCSV function not implemented')
  }

}

export default IPortal